import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Panel from '../../../../components/angle/Panel/index';
import Select from '../../../../components/Select/index';
import { formInputValidation } from '../../../../services/helper/form-helper';
import { Toastr } from '../../../../components/Toastr/index';
import { MONTH_NAMES } from '../../../../services/constant/constant';

class SearchReadyForRenewalPanel extends Component {
    constructor(props) {
        super(props);
        this.formRef = React.createRef();
        this.state = {
            clientId: '',
            startDate: '',
            startDatePicker: '',
            endDate: '',
            endDatePicker: '',
            selectedTimeOption: {
                index: 0,
                label: 'Custom Time Period'
            }
        };
        this.dateOptions = this.setTimePeriodOptions();
    }
    componentDidMount() {
        let { user } = this.props;
        if (user && user.roleName === 'User') {
            this.setState({
                clientId: user.clientId
            });
        }
    }

    setTimePeriodOptions = () => {
        let date = new Date(),
            y = date.getFullYear(),
            m = date.getMonth();
        return [
            {
                index: 0,
                label: 'Custom Time Period'
            },
            {
                index: 1,
                label: MONTH_NAMES[(m - 1 + 12) % 12],
                startDate: new Date(Date.UTC(y, m - 1, 1)),
                endDate: new Date(Date.UTC(y, m, 0, 23, 59, 59))
            },
            {
                index: 2,
                label: MONTH_NAMES[m],
                startDate: new Date(Date.UTC(y, m, 1)),
                endDate: new Date(Date.UTC(y, m + 1, 0, 23, 59, 59))
            },
            {
                index: 3,
                label: MONTH_NAMES[(m + 1 + 12) % 12],
                startDate: new Date(Date.UTC(y, m + 1, 1)),
                endDate: new Date(Date.UTC(y, m + 2, 0, 23, 59, 59))
            },
            {
                index: 4,
                label: 'Last year',
                startDate: new Date(Date.UTC(y - 1, 0)),
                endDate: new Date(Date.UTC(y - 1, 11, 31, 23, 59, 59))
            },
            {
                index: 5,
                label: 'This year',
                startDate: new Date(Date.UTC(y, 0)),
                endDate: new Date(Date.UTC(y, 11, 31, 23, 59, 59))
            }
        ];
    };

    handleTimePeriodChange = (name, option) => {
        this.setState({
            selectedTimeOption: option,
            startDatePicker: '',
            endDatePicker: ''
        });
    };

    handleDateChange = (name, value) => {
        this.setState({
            [name]: value ? value : ''
        });
    };

    handleSelectChange = (type, value) => {
        this.props.onClientChange({
            [type]: value ? value.clientId : ''
        });
    };

    logicValidation = () => {
        let { selectedTimeOption, startDatePicker, endDatePicker } = this.state;
        let errorMessage = '';
        if (selectedTimeOption.index === 0) {
            if (endDatePicker >= startDatePicker) {
                return true;
            } else {
                errorMessage =
                    'End date must be equal or greater than start date';
            }
        }
        Toastr.error(errorMessage);
        return false;
    };

    onSearch = () => {
        let { onSearchClick } = this.props;
        //let { clientId } = this.state;
        if (formInputValidation(this.formRef.current)) {
            onSearchClick();
        }
    };
    render() {
        let { clientList, user, clientSelected } = this.props;
        //let { clientId } = this.state;
        let viewButton = (
            <button
                type="button"
                className="btn btn-default btn-bordered"
                onClick={this.onSearch}
            >
                Search
            </button>
        );
        const buttonList = [viewButton];
        return (
            <Panel
                showFooter
                footerComponents={buttonList}
                panelStyle="panel-default m0"
            >
                <form ref={this.formRef}>
                    <div className="row">
                        <div className="col-md-6 mb">
                            <Select
                                id="filingByEffDateClientId"
                                name="readyForRenewalClientId"
                                placeholder="Choose a Client"
                                labelKey="name"
                                valueKey="clientId"
                                selectedValue={clientSelected}
                                onChange={this.handleSelectChange}
                                options={clientList}
                                required={true}
                                disabled={
                                    user && user.roleName !== 'Administrator'
                                }
                            />
                        </div>
                    </div>
                </form>
            </Panel>
        );
    }
}

SearchReadyForRenewalPanel.propTypes = {
    onSearchClick: PropTypes.func.isRequired
};

export default SearchReadyForRenewalPanel;



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/SearchFilings/SearchReadyForRenewalPanel.js